// Internal modules
import { logger } from '@/lib/logger';

const COMMON_KEYS = {
  component: 'checkoutuinodeweb_weasley',
  state_name: 'billing',
};

export const logToggleSignupButton = (isSignup: boolean): void => {
  logger.fpti('billing_interactive_review_signup_toggle_pressed', {
    event_name: 'billing_interactive_review_signup_toggle_pressed',
    transition_name: 'process_billing_page_interactive_toggle',
    user_opts_signup: isSignup ? 'y' : 'n',
    ...COMMON_KEYS,
  });
};

export const logFPTIInitialToggleState = (isSignup: boolean): void => {
  logger.fpti('billing_interactive_review_signup_toggle_load', {
    event_name: 'billing_interactive_review_signup_toggle_shown',
    transition_name: 'prepare_billing_signup_toggle',
    user_opts_signup: isSignup ? 'y' : 'n',
    ...COMMON_KEYS,
  });
};
